(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-checkbox-only-one").forEach(function (checkbox) {
      checkbox.addEventListener("click", function () {
        if (this.checked) {
          document.querySelectorAll(".js-checkbox-only-one").forEach(function (cb) {
            cb.checked = false;
          });
          this.checked = true;
        }
      });
    });
  });
})();
